import React, { useState } from 'react'
import Row, { Slot } from './row'
import Button from './button'
import styles from '../component-styles/enterprise-card.module.scss'
import ContactUsModal from './contact-us-modal'

export default function EnterpriseCard(): React.ReactElement {
  const [active, setActive] = useState(false)
  return (
    <>
      <ContactUsModal
        active={active}
        toggleActive={() => setActive((a) => !a)}
      />
      <div className={styles.card}>
        <Row centerAtMobile>
          <Slot align="flex-start" centerAtMobile>
            <h3 className={styles.title}>Are you an Enterprise or Agency?</h3>
          </Slot>
          <Slot align="flex-end" width={120} centerAtMobile>
            <Button onClick={() => setActive((a) => !a)} type="squareGrey">
              Book a Demo
            </Button>
          </Slot>
        </Row>
      </div>
    </>
  )
}
